import React from 'react';
import { getTargetURL } from '../../../../misc/getTargetURL';
import ActionButton from '../../../elements/ActionButton/ActionButton';
import { useI18n } from '../../../../data/hooks/i18nHooks';

function NewsTargetButton(props) {
    const { eventId, article } = props,
        { target_screen, target_button_text } = article,
        href = getTargetURL(eventId, target_screen),
        i18n = useI18n();

    if (!target_screen) return null;

    return (
        <ActionButton secondary next href={href}>
            {target_button_text || i18n['label.open']}
        </ActionButton>
    );
}

export default NewsTargetButton;
